module.exports = __webpack_public_path__ + "static/media/team-health-pool-flyer-768x591.cf5a9e18.jpg";